var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-end"},[(_vm.showSubmit)?_c('SrButton',{staticClass:"ml-2",attrs:{"disabled":!_vm.canSubmit,"loading":_vm.loading,"type":"secondary"},on:{"click":function($event){return _vm.$emit('submit-clicked')}}},[_vm._v(" Submit ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }